module.exports = __webpack_public_path__ + "res/Roboto-Italic-webfontd41d.eot?ceca5bb409e1682e410cb760e50d1273";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Italic-webfontd41d.eot
// module id = 22
// module chunks = 0